import { throttle } from 'lodash-es';

export default {
  props: {
    movementTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    parentContainer: {
      type: Element,
      default: null,
    },
    trackedKeys: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  created() {
    this.onMouseMoveThrottled = throttle(this.onMouseMove, 10);
  },
  mounted() {
    if (this.movementTrackingEnabled && this.parentContainer) {
      this.enableMovementTracker();
    }
  },
  beforeUnmount() {
    this.disableMovementTracker();
  },
  watch: {
    movementTrackingEnabled(enabled) {
      if (enabled) {
        this.enableMovementTracker();
      } else {
        this.disableMovementTracker();
      }
    },
  },
  computed: {
    isVisible() {
      return !this.movementTrackingEnabled || !!this.visible;
    },
  },
  methods: {
    onMouseMove(event) {
      const box = this.parentContainer?.getBoundingClientRect();
      if (!box) return;

      // are the mouse coordinates inside of the parent Container??
      this.visible = (
        event.clientX <= box.right
        && event.clientX >= box.left
        && event.clientY <= box.bottom
        && event.clientY >= box.top
      );
    },
    onKeyup(event) {
      if (this.trackedKeys.includes(event.key) || this.trackedKeys.includes(event.keyCode)) {
        this.visible = true;
      }
    },
    enableMovementTracker() {
      document.addEventListener('mousemove', this.onMouseMoveThrottled);
      document.addEventListener('keyup', this.onKeyup);
    },
    disableMovementTracker() {
      document.removeEventListener('mousemove', this.onMouseMoveThrottled);
      document.removeEventListener('keyup', this.onKeyup);
    },
  },
};
